<template>
  <div class="actor-card">
    <div class="actor-card-bottom-box">
      <div class="actor-card-booth">
        <span style="margin-right: 10px;">{{ $t('展位号') }}</span>
        <span class="booth">{{ vData.exhibitionBoothNumber}}</span>
      </div>

    </div>
    <div class="actor-card-bottom-box">
      {{ vData['name'] || vData['exhibitorName'] || vData['atrName'] }}
    </div>
    <div class="flex actor-card-main">
      <div class="actor-card-main-left">
        {{ vData.introduction }}
      </div>
      <div class="actor-card-main-middle"></div>
      <div class="actor-card-main-right">
        <div class="flex-center">
          <div @click.stop="collect(vData)">
            <template v-if="vData['collected']">
              <img class="iconact_dianzan_full pointer" src="@/assets/card/collect.png" />
            </template>
            <template v-else>
              <img class="iconact_dianzan_full pointer" src="@/assets/card/no_collect.png" />
            </template>
          </div>

          <!-- <img class="m-l-9 m-r-10" style="vertical-align: middle;" src="@/assets/card/thumbs-up.png" /> -->
          <i class="m-l-9 m-r-10 el-icon-view"
            style="vertical-align: middle;font-weight: bold;color: rgba(0,0,0,0.45);"></i>
          <span style="vertical-align: middle;color: rgba(0,0,0,0.45);">{{ vData.pageView || 0 }}</span>
        </div>
        <div class="detail-box">
          <span class="detail" @click="goDetail(vData)">{{ $t('查看详情') }}</span>
          <span class="pointer" @click="goUrl(vData)">
            <img src="@/assets/card/promotion.png" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
  },
  props: {
    vData: {
      type: [Object],
      default: () => { }
    },
    showType: {
      type: String,
      default: 'find'
    },
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {}
  },
  async mounted() { },
  methods: {
    // 进入展商详情
    goDetail(item) {
      if (!this.isLogin) {
        sessionStorage.setItem('actorID', item.id)
      }
      if (this.showType == 'find') {
        this.$router.push(`/actorDetail/${item.id}`)
      } else {
        this.$router.push(`/actorDetail/${item.actorId}`)
      }
    },
    //收藏
    collect(data) {
      if (this.showType === 'collection') {
        this.$emit(
          'collect',
          {
            id: data.id,
            deleted: true,
            collectionSubjectType: 'ACTOR',
            collectionSubjectId: data.actorId
          },
          this.index
        )
      } else {
        this.$emit(
          'collect',
          {
            id: data.collectionId,
            deleted: data.collected,
            collectionSubjectType: 'ACTOR',
            collectionSubjectId: data.exhibitorId
          },
          this.index,
          data
        )
      }
    },
    // 跳转第三方页面
    goUrl(data) {
      // if (data?.url3d) {
      //   window.open(data.url3d, '_blank')
      // }
      // 中英文跳转不同链接
      if (this.language == 'en') {
        window.open(`https://szdt.3dqiye.com/boothplan?exhibitionId=08dd467e763b4db08aa1b40396d06e96&lang=en&boothNum=${data.exhibitionBoothNumber}`, '_blank')
      } else {
        window.open(`https://szdt.3dqiye.com/boothplan?exhibitionId=08dd467e763b4db08aa1b40396d06e96&boothNum=${data.exhibitionBoothNumber}`, '_blank')
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
.actor-card{
  margin-bottom: 20px;
}
.actor-card-bottom-box{
  border-bottom: 1px solid #038720;
  line-height: 40px;
}
.actor-card-booth{
  display: inline-block;
  padding:0 16px;
  background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
  color: #fff;
  min-height: 40px;
  line-height: 40px;

  span{
    font-size: 14px;
    vertical-align: middle;
  }
  .booth{
    font-size: 22px;
  }
}
.actor-card-main{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0;
  .actor-card-main-left{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 根据你的字体和布局调整行高 */
    max-height: 40px;
    /* 行高*行数，例如1.2em*2=2.4em */
    width:850px;
    padding: 0 30px 0 0;
    
    border-bottom: none;
  }
  .actor-card-main-middle{
    width: 1px;
    height: 40px;
    background: #038720;
  }
  .actor-card-main-right{
    width: 150px;
    text-align: center;
  }
}
.iconfont {
  margin: 9px 8px;
}
.iconact_dianzan_full{
  border-right: 1px solid #038720;
  padding-right: 10px;
}
.iconxianshimima{
  margin-left: 0;
}
.detail-box{
  margin-top: 10px;
}
.detail{
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #00875e;
  height: 26px;
  padding: 3px 12px;
  margin-right: 4px;
  vertical-align: middle;
  background: -webkit-linear-gradient(top, #00875e, #0068a9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  cursor: pointer;
}

@media (min-width: 320px) and (max-width: 750px) {
  .actor-card-main {
      display: block;
  
      .actor-card-main-left {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
        width: auto;
        padding: 0 0 30px 0;
        border-right: none;
      }
      .actor-card-main-middle {
        margin: 15px 0 10px;
        width: 100%;
        height: 1px;
        background: #038720;
      }
      .actor-card-main-right {
        width: auto;
        text-align: center;
        display: flex;
        align-items: self-end;
        justify-content: space-between;
      }
    }
}
</style>